<script>

import axios from 'axios';

export default class VisitasRepository{
    
    async getVisitas(page,token,rawdata){
        
        const baseURL = page
        const headers = {
            'Content-Type': 'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
        const data = rawdata;
        const response = await axios.post(baseURL, data,{ headers: headers });
        return response;

    }

    async createProposta(page, rawdata, token) {
        const baseURL = page;
        const headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        if (!(rawdata instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
        }
        try {
            const response = await axios.post(baseURL, rawdata, { headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar proposta:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getSeguradoData(page, token, seguradoId,visitaDependente) {
        const baseURL = `${page}${seguradoId}/${visitaDependente}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL, { headers });
        return response; // Retorna só os dados, já que teu código espera o JSON direto
    }

    async updateStatus(page, token, id) {
        const baseURL = `${page}${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL, { headers });
        return response.data; // Retorna só os dados, já que teu código espera o JSON direto
    }

    async getVisitasAtivas(page, token) {
        const baseURL = page;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL, { headers });
        return response; // Retorna só os dados, já que teu código espera o JSON direto
    }

    async createLista(page,rawdata,token){
        
        const baseURL = page;
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

    async  deleteLista(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async  getVisita(page,token,id) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

    async  updateLista(page,token,id,rawdata) {
        
        const baseURL = `${page}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const data = rawdata;
        const response = await axios.put(baseURL,data,{ headers });
        return response;
       
    }

}
</script>
